import styled from 'styled-components';

export const CompanyButtonContainer = styled.div.attrs({})`
  width: 100%;
  display: flex;
  gap: 16px;
`;

export const AddProposalContainer = styled.div.attrs({})`
  padding: 20px 0px;
`;

export const BotaoDocumento = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 12px 20px;
  width: auto;
  min-width: 110px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 16px;
  margin-top: 16px;
  margin-right: 18px;
  transition: all 0.2s ease-in-out;
  background-color: ${(props) =>
    props.hasFile ? 'rgba(40, 167, 69, 0.1)' : '#f5f5f5'};
  color: ${(props) => (props.hasFile ? '#28a745' : '#999999')};
  border: 1px solid ${(props) => (props.hasFile ? '#28a745' : '#dcdcdc')};
  cursor: ${(props) => (props.hasFile ? 'pointer' : 'not-allowed')};
  pointer-events: ${(props) => (props.hasFile ? 'auto' : 'none')};
  opacity: ${(props) => (props.hasFile ? '1' : '0.7')};
  &:hover {
    ${(props) =>
      props.hasFile &&
      `
      color: #ffffff;
      background-color: #28a745;
      border-color: #218838;
    `}
  }
`;

export const BotaoAnexar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  width: auto;
  min-width: 140px;
  margin-top: 16px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-color: #2670d1;
  color: #ffffff;
  border: 1px solid #2670d1;
  &:hover {
    background-color: #1e56a0;
    border-color: #1e56a0;
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  &:active {
    transform: translateY(0);
    background-color: #1a4a8a;
  }
`;

export const RowContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  & > div:first-child {
    width: 100%;
  }
`;
export const AlertaPendencia = styled.div`
  background-color: #fff4e5;
  color: #663c00;
  padding: 10px 15px;
  border-radius: 4px;
  font-size: 13px;
  margin-bottom: 10px;
  margin-top: 5px;
  border-left: 5px solid #ffa117;
  display: flex;
  flex-direction: column;
  gap: 4px;
  strong {
    font-weight: 700;
  }
`;

export const ListaPendencia = styled.ul`
  margin: 0;
  padding-left: 20px;
  li {
    margin-top: 2px;
  }
`;
